import React from 'react'
import { useCodebookApi } from '../../hooks/useCodebook'
import { TableWrapper, Table } from '../common/Table'
import LoadInView from '../common/LoadInView'
import { Title, Description } from '../common/System'

const ViewAllCodebook = () => {
  const {isLoading, data } = useCodebookApi()

  if (isLoading) {
    return (
      <div>
        <Title>데이터 보기: 학과분류체계</Title>
        <h3>
          Loading...
        </h3>
      </div>
    )
  } else {
    return (
      <div>
        <Title>학과분류체계 보기</Title>
        <Description>96개 학과의 분류체계를 볼 수 있습니다.</Description>
        <LoadInView>
          <TableWrapper>
            <Table>
              <colgroup>
                <col width="5%"/>
                <col width="10%"/>
                <col width="10%"/>
                <col width="20%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>최상위분류</th>
                  <th>계열</th>
                  <th>학과</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((cb: codebookType, index: number) => (
                  <tr key={index}>
                    <td key={index}>{index+1}</td>
                    <td key={cb.lv1}>{cb.lv1}</td>
                    <td key={cb.lv2}>{cb.lv2}</td>
                    <td key={cb.lv4}>{cb.lv4}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </TableWrapper>
        </LoadInView>
      </div>
    )
  }
}

export default ViewAllCodebook

interface codebookType {
  lv1: string,
  lv2: string,
  lv4: string,
}